export default "__VITE_ASSET__576c1db7__"